import { Navigate, createFileRoute } from "@tanstack/react-router";

/** Legacy path — Development queue was replaced by the Delivery board. */
export const Route = createFileRoute("/_app/requests/queue")({
  component: () => <Navigate to="/requests/delivery" replace />,
});
